import React from "react";
import styled from "styled-components";

import { Alert, Column, Columns } from "@origin-digital/ods-core";

const PhoneLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

// wordpress page is setting a { color: inherit; } which is cauing the link to appear gray instead of blue
const Link = styled.a`
  color: revert;
`;

export const LookupErrorAlert: React.FC = () => {
  return (
    <Columns alignX="center" collapseBelow="lg" space="small">
      <Column width="3/4">
        <Alert title="Sorry" tone="critical" data-id="lookup-error-alert">
          We're sorry, but we're unable to sign you up online right now. Please
          call us on <PhoneLink href="tel:132461">13 24 61</PhoneLink> or email
          us at{" "}
          <Link href="mailto:hello@origin.com.au">hello@origin.com.au</Link> for
          plans and pricing available at your address.
        </Alert>
      </Column>
    </Columns>
  );
};
